import { useTranslation } from "react-i18next"
import { DestinationMark } from "./types"
import { useState } from "react"
import { useStyles } from "./styles"
import { Box, Typography } from "@mui/material"
import { CaptionKeyVertical } from "../../../../../../../components/detailKeyValue/keyCaption.index"


const MapMarkerDestination = ({ Node, ...props }: DestinationMark) => {
    const { t } = useTranslation()
    const { companyName, createdDate, direction, lat, long, name, userCreator } = props
    const styles = useStyles()
    const [showTooltip, setShowTooltip] = useState(false)

    return (
        <Box sx={[styles.relative]} onMouseOut={() => setShowTooltip(false)} onMouseOver={() => setShowTooltip(true)}>
            {showTooltip && (
                <Box sx={[styles.flex, styles.containerTooltip, styles.padding]}>
                    <Typography variant='text_grey' fontWeight='bold' fontSize={16}>{name}</Typography>

                    <CaptionKeyVertical caption={t('loogbook.createdDate')} captionProps={{ sx: { width: '39%' } }} valueProps={{ sx: { width: '59%' } }} value={createdDate || 'N/A'} />

                    <CaptionKeyVertical caption={t('loogbook.userCreator')} captionProps={{ sx: { width: '39%' } }} valueProps={{ sx: { width: '59%' } }} value={userCreator || 'N/A'} />

                    <CaptionKeyVertical caption={t('loogbook.direction')} captionProps={{ sx: { width: '39%' } }} valueProps={{ sx: { width: '59%' } }} value={direction || 'N/A'} />
                    
                    <CaptionKeyVertical caption={t('loogbook.latitudeAndLongitude')} captionProps={{ sx: { width: '39%' } }} valueProps={{ sx: { width: '59%' } }} value={`${lat} ${long}` || 'N/A'} />
                    
                    <CaptionKeyVertical caption={t('loogbook.company')} captionProps={{ sx: { width: '39%' } }} valueProps={{ sx: { width: '59%' } }} value={companyName || 'N/A'} />
                </Box>
            )}

            <Box sx={styles.userPoint} >
                {Node && <Node />}
            </Box>

        </Box>
    )
}

export { MapMarkerDestination }